export const EditIcon = (color = "#6C757D") => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 3.00003L9 4.50003M6.5 10H10.5M2.5 8.00003L2 10L4 9.50003L9.793 3.70703C9.98047 3.5195 10.0858 3.2652 10.0858 3.00003C10.0858 2.73487 9.98047 2.48056 9.793 2.29303L9.707 2.20703C9.51947 2.01956 9.26516 1.91425 9 1.91425C8.73484 1.91425 8.48053 2.01956 8.293 2.20703L2.5 8.00003Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TrashIcon = (color = "#6C757D") => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.206 3.25L8.8055 10.0585C8.79058 10.3132 8.67887 10.5525 8.49325 10.7276C8.30763 10.9026 8.06213 11.0001 7.807 11H4.193C3.93787 11.0001 3.69237 10.9026 3.50675 10.7276C3.32113 10.5525 3.20942 10.3132 3.1945 10.0585L2.795 3.25H1.75V2.75C1.75 2.6837 1.77634 2.62011 1.82322 2.57322C1.87011 2.52634 1.9337 2.5 2 2.5H10C10.0663 2.5 10.1299 2.52634 10.1768 2.57322C10.2237 2.62011 10.25 2.6837 10.25 2.75V3.25H9.206ZM5 1.25H7C7.0663 1.25 7.12989 1.27634 7.17678 1.32322C7.22366 1.37011 7.25 1.4337 7.25 1.5V2H4.75V1.5C4.75 1.4337 4.77634 1.37011 4.82322 1.32322C4.87011 1.27634 4.9337 1.25 5 1.25ZM4.5 4.5L4.75 9H5.5L5.3 4.5H4.5ZM6.75 4.5L6.5 9H7.25L7.5 4.5H6.75Z"
        fill={color}
      />
    </svg>
  );
};

export const MiniLoaderIcon = () => {
  return (
    <svg
      aria-hidden="true"
      className="w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill"
      />
    </svg>
  );
};

export const DownArrowIcon = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 2.90223L1.49996 2.90223C1.40884 2.90252 1.31952 2.92765 1.24162 2.97492C1.16372 3.02219 1.10019 3.08981 1.05786 3.17051C1.01553 3.2512 0.996015 3.34191 1.00141 3.43287C1.0068 3.52383 1.03689 3.6116 1.08846 3.68673L5.58846 10.1867C5.77496 10.4562 6.22396 10.4562 6.41096 10.1867L10.911 3.68673C10.963 3.61176 10.9936 3.52395 10.9993 3.43283C11.005 3.34172 10.9856 3.25079 10.9432 3.16993C10.9008 3.08906 10.8371 3.02135 10.759 2.97416C10.6808 2.92696 10.5912 2.90209 10.5 2.90223Z"
        fill="#344054"
      />
    </svg>
  );
};

export const RightArrowIcon = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.49995 1.9022L2.49995 10.9022C2.50023 10.9933 2.52536 11.0826 2.57264 11.1605C2.61991 11.2384 2.68753 11.302 2.76822 11.3443C2.84892 11.3866 2.93963 11.4061 3.03059 11.4008C3.12155 11.3954 3.20932 11.3653 3.28445 11.3137L9.78445 6.8137C10.0539 6.6272 10.0539 6.1782 9.78445 5.9912L3.28445 1.4912C3.20948 1.43912 3.12166 1.40857 3.03055 1.40289C2.93944 1.3972 2.84851 1.4166 2.76764 1.45896C2.68678 1.50133 2.61907 1.56504 2.57188 1.64319C2.52468 1.72133 2.4998 1.81091 2.49995 1.9022Z"
        fill="#344054"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50537 11.8976L8.0007 8.40222L11.496 11.8976M11.496 4.90689L8.00004 8.40222L4.50537 4.90689"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RetryIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_67_159)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.32 0.431197C8.70071 0.313368 10.0884 0.556203 11.347 1.13592C12.6056 1.71563 13.6921 2.61233 14.5 3.7382V2.1522C14.5 1.95328 14.579 1.76252 14.7197 1.62187C14.8603 1.48121 15.0511 1.4022 15.25 1.4022C15.4489 1.4022 15.6397 1.48121 15.7803 1.62187C15.921 1.76252 16 1.95328 16 2.1522V6.4022H11.75C11.5511 6.4022 11.3603 6.32318 11.2197 6.18253C11.079 6.04188 11 5.85111 11 5.6522C11 5.45329 11.079 5.26252 11.2197 5.12187C11.3603 4.98122 11.5511 4.9022 11.75 4.9022H13.477C12.7931 3.8321 11.8107 2.98578 10.6512 2.46779C9.4917 1.94979 8.20584 1.7828 6.95248 1.98746C5.69912 2.19212 4.53316 2.75945 3.59864 3.61937C2.66412 4.4793 2.00198 5.59415 1.694 6.8262C1.67128 6.92298 1.62955 7.01428 1.57123 7.09479C1.51291 7.1753 1.43917 7.24341 1.35429 7.29516C1.26942 7.34692 1.1751 7.38128 1.07682 7.39626C0.97854 7.41123 0.878265 7.40652 0.781825 7.38239C0.685385 7.35826 0.594703 7.31521 0.515053 7.25572C0.435404 7.19623 0.368375 7.1215 0.317865 7.03588C0.267355 6.95025 0.234371 6.85544 0.220832 6.75696C0.207293 6.65847 0.213469 6.55828 0.239 6.4622C0.643544 4.84462 1.5434 3.39388 2.81279 2.31274C4.08218 1.23161 5.65766 0.574128 7.319 0.432197L7.32 0.431197ZM3.92 15.2832C4.99199 15.9186 6.19758 16.2947 7.44068 16.3817C8.68378 16.4687 9.93001 16.2641 11.08 15.7841C12.23 15.3042 13.252 14.5623 14.0646 13.6175C14.8771 12.6727 15.4577 11.5511 15.76 10.3422C15.805 10.1504 15.7728 9.94858 15.6702 9.78036C15.5676 9.61215 15.403 9.49105 15.2119 9.44324C15.0207 9.39542 14.8185 9.42473 14.6488 9.52483C14.4791 9.62494 14.3556 9.78779 14.305 9.9782C13.9969 11.21 13.3347 12.3246 12.4002 13.1843C11.4658 14.044 10.3 14.6112 9.04688 14.8158C7.79373 15.0204 6.50809 14.8536 5.34871 14.3358C4.18933 13.818 3.20699 12.972 2.523 11.9022H4.25C4.44891 11.9022 4.63968 11.8232 4.78033 11.6825C4.92098 11.5419 5 11.3511 5 11.1522C5 10.9533 4.92098 10.7625 4.78033 10.6219C4.63968 10.4812 4.44891 10.4022 4.25 10.4022H0V14.6522C0 14.8511 0.0790176 15.0419 0.21967 15.1825C0.360322 15.3232 0.551088 15.4022 0.75 15.4022C0.948912 15.4022 1.13968 15.3232 1.28033 15.1825C1.42098 15.0419 1.5 14.8511 1.5 14.6522V13.0662C2.14478 13.9645 2.96879 14.7194 3.92 15.2832Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_67_159">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.402222)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const ICONS = {
  EditIcon,
  TrashIcon,
  DownArrowIcon,
  RightArrowIcon,
  CloseIcon,
  RetryIcon
};

export default ICONS;
